import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useResource = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getResourcesByProduct = async productId => {
    try {
      const response = await sendRequest({
        url: `/api/v1/resource/product/${productId}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      console.error('Error fetching resources:', err);
      throw err;
    }
  };

  const getResourcesByTypeAndEntertainment = async (type, entertainmentId) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/resource/type/${type}/entertainment/${entertainmentId}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      console.error('Error fetching resources by type and entertainment:', err);
      throw err;
    }
  };

  const getResourcesByEntertainmentId = async (entertainmentId, includeOrdered = false) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/resource/entertainment/${entertainmentId}${
          includeOrdered ? '?withOrdered=true' : ''
        }`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      console.error('Error fetching resources by entertainment:', err);
      throw err;
    }
  };

  const getResourceById = async resourceId => {
    try {
      const response = await sendRequest({
        url: `/api/v1/resource/${resourceId}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      console.error('Error fetching resource by id:', err);
      throw err;
    }
  };

  return {
    isLoading,
    error,
    getResourcesByProduct,
    getResourcesByTypeAndEntertainment,
    getResourcesByEntertainmentId,
    getResourceById,
  };
};

export default useResource;
